import { cipo } from 'cipo';

cipo.controller('progresspaymentController',
    function ($transition$, $scope, $state, Model, userService, currencyService, URI, ProgressPaymentSA, $q, Message, $mdDialog, Dictionaries) {
        const moduleCode = 'PP';
        const routeParams = {...$transition$.params()};

        $scope.paramsEntityInstanceId = routeParams.entityInstanceId;
        $scope.module = userService.system.modules[moduleCode];
        // needed for template module_table.html
        $scope.node = null;
        $scope.module.baseName = $scope.module.name;
        $scope.collapsedDetails = false;

        $scope.sovModuleName = userService.system.modules['SOV']?.name || 'SOV';
        
    	userService.setLastVisitedModule($scope.module.moduleId);

        // get live operations
        Object.defineProperty($scope, 'operations', {
            get: function () { return userService.getOperationsFor(moduleCode); }
        });

        Object.defineProperty($scope, 'hasManageDrafts', {
            get: function () { return $scope.operations["Manage Drafts"]; }
        });

        Object.defineProperty($scope, 'decimalSeparator', {
            get: function () { return userService.userSettings().decimalSeparator; }
        });

        currencyService.getAndSetCurrencyById($scope);
        
        Object.defineProperty($scope, 'userService', {
            get: function () {
                return userService;
            }
        });

        Object.defineProperty($scope, 'nonBindingSignature', {
            get: function () {
                return userService.userHasSignature(); }
        });

        var moduleTypes;
        var moduleTypesPromise = Dictionaries.ModuleTypes(-3)
            .then(function (r) {
                moduleTypes = r;
            })
            .catch(function () {})

        $scope.isPaymentRequestAllowed = function (selectedPeriodRequired) {
            if (selectedPeriodRequired && !$scope.selectedPeriod)
                return false;
            return !$scope.selectedPeriod ||
                $scope.selectedPeriod.key == $scope.currentPeriod.id ||
                ($scope.currentPeriod.allowedPastPeriodIDs || []).indexOf($scope.selectedPeriod.key) != -1
                ;
        }

        $scope.$on("$mdMenuClose", function () {
            try {
                $scope.pp.assignments.searchUser = '';
            } catch { }
        });

        $scope.showPercentageEditable = function () {
            if ($scope.pp.generalInfo.isContractClosedOrArchived) return false;
            if ($scope.pp.generalInfo.approvalId) return false;
            if ($scope.pp.generalInfo.isDraftState && $scope.pp.isEditablePercentage) return true;
            if ($scope.pp.editMode && $scope.pp.isEditablePercentage) return true;
            return false;
        }

        $scope.showAmountEditable = function () {
            if ($scope.pp.generalInfo.isContractClosedOrArchived) return false;
            if ($scope.pp.generalInfo.approvalId) return false;
            if ($scope.pp.generalInfo.isDraftState && $scope.pp.isEditableAmount) return true;
            if ($scope.pp.editMode && $scope.pp.isEditableAmount) return true;
            return false;
        }

        $scope.showQuantityEditable = function () {
            if ($scope.pp.generalInfo.isContractClosedOrArchived) return false;
            if ($scope.pp.generalInfo.approvalId) return false;
            if ($scope.pp.generalInfo.isDraftState && $scope.pp.isEditableQuantity) return true;
            if ($scope.pp.editMode && $scope.pp.isEditableQuantity) return true;
            return false;
        }

        $scope.canEditValue = function () {
            if ($scope.pp.generalInfo.isContractClosedOrArchived) return false;
            if ($scope.pp.generalInfo.approvalId) return false;
            if ($scope.pp.generalInfo.isDraftState) return true;
            if ($scope.pp.editMode) return true;
            return false;
        }

        $scope.showEditableInput = function (item, col, module) {
            if ($scope.pp.generalInfo.isContractClosedOrArchived) return false;
            if (col.isEditableAmount && $scope.showAmountEditable() && !item.readonly && !module.isBlocked) return true;
            if (col.isEditablePercentage && $scope.showPercentageEditable() && !item.readonly && !module.isBlocked) return true;
            if (col.isEditableQuantity && $scope.showQuantityEditable() && !item.readonly && !module.isBlocked) return true;
            if (col.canBeModifiedOnPP && $scope.canEditValue() && !item.readonly && !module.isBlocked) return true;
            if (col.type == 'button' && $scope.canEditValue() && !item.readonly && !module.isBlocked) return true;
            return false;
        }

        $scope.approve = function (isApprove) {
            $scope.pp.approve(isApprove)
                .then(function (r) {
                    if (!$scope.selectedPeriod.isMultiplePeriod && isApprove) {
                        $scope.selectedPeriod.hasMultiplePayments = false;
                    };
                    $scope.get_periods();
                })
                .catch(function () { })
        }

        $scope.goToProgressPayment = function(periodId, entityInstanceId, sovEntityInstanceId) {
            var paramsNew = angular.copy(routeParams);
            paramsNew.periodId = periodId || 0;
            paramsNew.entityInstanceId = entityInstanceId || 0;
            if (sovEntityInstanceId && !entityInstanceId) {
                paramsNew.sovEid = sovEntityInstanceId;
            }
            $state.go('tenant.progresspayment', paramsNew, { reload: true });
        }

        $scope.loadPPDetails = function (pp, period) {
            $scope.errors = "";
            checkInitiator();
            if (period && $scope.selectedPeriod && period.key != $scope.selectedPeriod.key) {
                $scope.selectedPeriod = period;
                if (!period.hasMultiplePayments) {
                    $scope.goToProgressPayment($scope.selectedPeriod.key, $scope.selectedPeriod.entityInstanceId, $scope.pp?.generalInfo?.sovEntityInstanceId || $scope.selectedPeriod.sovEntityInstanceId);
                }
                else {
                    $scope.pp = null;
                    $scope.get_ppList(period.key);
                }
            } else {
                $scope.goToProgressPayment(0, pp?.id);
            }
        }

        $scope.movePP = function (pp, period, event) {
            if (event) event.stopPropagation(); 
            var dataURL = URI.PROGRESS_PAYMENT.PP_MOVE;
            var params = {
                entityInstanceId: pp.entityInstanceId,
                periodId: period.key,
                contractId: userService.system.userdata.contractId || 0
            };

            Model[dataURL.method](dataURL, { url: params, urltype: 'obj' })
                .then(function (r) {
                    if (r) Message.warning(r);

                    $scope.get_periods()
                        .then(function() {
                            $scope.loadPPDetails(null, period);
                        })
                })
                .catch(function (e) {
                    Message.dberror(e);
                })
        }

        $scope.canMovePP = function (periodId) {
            return $scope.pp?.generalInfo?.availableMovePeriodIds?.includes(periodId) || false;
        }

        $scope.userIsInitiator = false;
        var checkInitiator = function () {
            var dataURL = URI.PROGRESS_PAYMENT.PP_IS_USER_INITIATOR;
            var params = {
                contractId: userService.system.userdata.contractId || 0
            };

            Model[dataURL.method](dataURL, { url: params, urltype: 'obj' })
                .then(function (r) {
                    $scope.userIsInitiator = r;
                })
                .catch(function (e) {
                    Message.dberror(e);
                })
        }
        checkInitiator();       

        $scope.get_ppList = function (periodId) {
            $scope.loadingList = true;
            $scope.pp = null;
            checkInitiator();
            var p = $q.defer();
            var period = periodId || ($scope.currentPeriod || {}).id;
            var dataURL = URI.PROGRESS_PAYMENT.PP_MULTIPLE_SEARCH;
            var params = {
                contractId: userService.system.userdata.contractId,
                paymentPeriodId: period || 0
            };
            $scope.hasDraft = false;
            Model[dataURL.method](dataURL, { url: params, urltype: 'obj' })
                .then(function (r) {
                    for (var i = 0; i < r.data.length; i++) {
                        if (r.data[i].isDraft && (!r.data[i].is_approval || r.data[i].isOwner) || (r.data[i].isRevision && !($scope.selectedPeriod || $scope.currentPeriod).isMultiplePeriod)) {
                            $scope.hasDraft = true;
                        }
                    }
                    $scope.ppList = r.data;

                    p.resolve(r);
                })
                .catch(function (e) {
                    Message.dberror(e);
                    p.reject(e);
                })
                .finally(function () {
                    $scope.loadingList = false;
                    // self.isBusy = false;
                })

            return p.promise;
        };
        var isPeriodsLoaded = false;
        $scope.multiPPCols = [
            { name: 'paidAmount', label: "Paid amount"},
            { name: 'totalAmount', label: "Total amount" },
            { name: 'status', label: "Status", isStatus: true },
            { name: 'updatedOn', label: "Updated on"},
            { name: 'updatedBy', label: "Updated by" },
            { name: 'createdOn', label: "Created on" },
            { name: 'createdBy', label: "Created by"}
        ];

        $scope.get_currentPeriod = function () {
            var p = $q.defer();
            $scope.errors = "";
            $scope.isCurrentPeriodLoaded = false;
            $scope.isBusyPeriods = true;

            var dataURL = URI.PROGRESS_PAYMENT.PPD_CURRENT;
            Model[dataURL.method](dataURL, { url: { contractId: userService.system.userdata.contractId }, urltype: 'obj' })
                .then(function (r) {
                    if (r) {
                        r.startDate = r.startDate ? userService.formatDate(r.startDate) : "";
                        r.endDate = r.startDate ? userService.formatDate(r.endDate) : "";
                    }
                    $scope.currentPeriod = r;
                    $scope.isCurrentPeriodLoaded = true;
                   
                    p.resolve();
                })
                .catch(function (e) {
                    p.reject(e);
                })
                .finally(function() {
                    if (!isPeriodsLoaded) {
                        $scope.get_periods()
                            .then(function() {
                                $scope.reloadOrGetPP();
                            });
                    }
                    else {
                        $scope.selectedPeriod = periodsLookup[$scope.currentPeriod.id];
                        $scope.reloadOrGetPP();
                    }
                });

            return p.promise;
        }

        var periodsLookup = {};

        var createLookup = function (data) {
            var ret = {};
            if (data && data.length)
                for (var i = 0; i < data.length; i++)
                    ret[data[i].key] = data[i];
            return ret;
        }


        $scope.get_periods = function (isFromWatch, sovEntityInstanceId) {
            
            var p = $q.defer();
            $scope.isBusyPeriods = true;
            var retainLoadedPP = false;
            Dictionaries.PPPeriods({ contractId: userService.system.userdata.contractId, ppEntityInstanceId: $scope.paramsEntityInstanceId || $scope.pp?.entityInstanceId, sovEntityInstanceId: sovEntityInstanceId || $scope.pp?.generalInfo?.sovEntityInstanceId || routeParams?.sovEid })
                .then(function (r) {
                    if (r && r.length) {
                        if (!$scope.currentPeriod) {
                            $scope.currentPeriod = { id: 0, key: 0, name: 'Current Period' };
                            $scope.selectedPeriod = $scope.currentPeriod;
                        }
                        for (var i = 0; i < r.length; i++) {
                            r[i].startDate = r[i].startDate ? userService.formatDate(r[i].startDate) : "";
                            r[i].endDate = r[i].startDate ? userService.formatDate(r[i].endDate) : "";
                            if (r[i].key == $scope.currentPeriod.id) {
                                r[i].current = true;
                                
                                for (var key in r[i])
                                    if (r[i].hasOwnProperty(key))
                                        $scope.currentPeriod[key] = r[i][key];
                                if(!$scope.selectedPeriod) $scope.selectedPeriod = r[i];
                            }
                            if (r[i].key == ($scope.selectedPeriod || {}).key) {
                                retainLoadedPP = true;
                                for (var key in r[i])
                                    if (r[i].hasOwnProperty(key))
                                        $scope.selectedPeriod[key] = r[i][key];
                            }
                        }

                        if (!$scope.currentPeriod.id) 
                            r.splice(0, 0, { key: 0, value: 'No Current Period', current: true });

                        $scope.periodsDict = r;
                    } 
                    else {
                        $scope.periodsDict = [];
                    }

                    if (!retainLoadedPP && isFromWatch) {
                        $scope.loadPP(false, true);
                    }

                    periodsLookup = createLookup(r);
                    p.resolve();
                    isPeriodsLoaded = true;
                })
                .catch(function (e) {
                    console.error(e);
                    Message.dberror(e);
                    p.reject(e);
                })
                .finally(function () {
                    $scope.isBusyPeriods = false;
                })

            return p.promise;
        }

        $scope.createPP = function (screenId) {
            if (!$scope.pp) 
                $scope.pp = new ProgressPaymentSA($scope.module, 0, moduleTypes, ($scope.selectedPeriod || {}).key, true, screenId, null);

            const currentSovEntityInstanceId = $scope.pp?.generalInfo?.sovEntityInstanceId || routeParams?.sovEid;
            if (($scope.pp.generalInfo.sovs?.length ?? 0) > 1 && !currentSovEntityInstanceId) {
                var dialogLocals = {
                    data: {
                        title: "Choose " + $scope.sovModuleName,
                        buttonLabels: [
                            { key: 'confirm', value: 'Proceed' },
                            { key: 'cancel', value: 'Cancel' },
                        ],
                        options: $scope.pp.generalInfo.sovs,
                        multiple: false
                    }
                };

                // Define dialog
                var dialog = $mdDialog
                    .confirm({
                        templateUrl: '/ng/views/system/modals/selectModal.tmpl.html',
                        controller: 'selectDialogController',
                        locals: dialogLocals,
                        parent: angular.element(document.body),
                        fullscreen: true,
                        focusOnOpen: false,
                        multiple: true,
                        escapeToClose: false,
                        clickOutsideToClose: false
                    });

                // Open dialog
                $mdDialog.show(dialog)
                    .then(function (sov) {
                        if (sov) {
                            $scope.createPPWithScreen(screenId, sov);
                        }
                    })
                    .catch(function (e) { p.reject(); });
            } else {
                const sovEntityInstanceId = $scope.pp.generalInfo.sovs?.some(s => s.key == currentSovEntityInstanceId) 
                                                    ? currentSovEntityInstanceId 
                                                    : $scope.pp.generalInfo.sovs?.find(s => s.revisions?.some(r => r.entityInstanceId == currentSovEntityInstanceId))?.key || $scope.pp.generalInfo.sovs[0]?.key;
                $scope.pp.sovEntityInstanceId = sovEntityInstanceId;
                $scope.createPPWithScreen(screenId, sovEntityInstanceId);
            }
        }

        $scope.createPPWithScreen = function (screenId, sovEntityInstanceId) {
            $scope.pp.isBusy = true;
            $scope.pp.propertiesScreen.get_fields()
                .then(function (r) {
                    $scope.collapsedDetails = false;
                    $scope.pp.isBusy = false;

                    if (r && r.fields && r.fields.length) {
                        $mdDialog
                            .show({
                                locals: {
                                    info: r,
                                    workflowId: $scope.pp.generalInfo.workflowId ?? userService.getWorkflowId($scope.module.moduleId),
                                    contractId: $scope.pp.generalInfo.contractId ?? userService.system.userdata.contractId,
                                    entityInstanceId: $scope.pp.generalInfo.entityInstanceId || 0,
                                    screenId: screenId,
                                    isDraftState: $scope.pp.generalInfo.isDraftState,
                                    documentNumber: $scope.pp.generalInfo.documentNumber,
                                    saveDocument: false,
                                    createURI: URI.PROGRESS_PAYMENT.PP_CREATE,
                                    saveURI: URI.PROGRESS_PAYMENT.PP_SAVE,
                                    moduleName: $scope.module.baseName,
                                    showSuccessMessage: true,
                                    uriParams: {
                                        contractId: $scope.pp.generalInfo.contractId || userService.system.userdata.contractId,
                                        screenId: screenId,
                                        sovEntityInstanceId: sovEntityInstanceId || 0,
                                    },
                                },
                                controller: "editScreenController",
                                templateUrl: "/ng/views/admin/modals/editScreen.html",
                                parent: angular.element(document.body),
                                fullscreen: true,
                                escapeToClose: false,
                                clickOutsideToClose: false,
                            })
                            .then(
                                function (fields) {
                                    $scope.createPPMethod(screenId, sovEntityInstanceId, fields)
                                },
                            );
                    } else {
                        $scope.createPPMethod(screenId, sovEntityInstanceId);
                    }
                })
                .catch(function (e) { $scope.pp.isBusy = false; });
        }

        $scope.createPPMethod = function(screenId, sovEntityInstanceId, fields) {
            $scope.pp.create(null, screenId, sovEntityInstanceId, fields)
                .then(function (r) {
                    $scope.get_periods(false, sovEntityInstanceId);
                })
                .catch(function (e) {});
        }

        $scope.reloadOrGetPP = function() {
            if ($scope.$$destroyed) {
                return;
            }
            moduleTypesPromise.then(function() {
            var hasSelectedPeriod = $scope.selectedPeriod && ($scope.selectedPeriod.key * 1) !== 0;
            var periodId = routeParams.periodId * 1, hasPeriod = periodId !==0;
            var entityInstanceId = routeParams.entityInstanceId * 1, hasEntityInstanceId = entityInstanceId !==0;

            $scope.hasManageDrafts;
            if (!hasSelectedPeriod && hasEntityInstanceId) {
                // find period based on entityInstanceId
                $scope.selectedPeriod = ($scope.periodsDict || [])
                    .find(p => (p.entityInstances || []).some(e => 
                        // take requested entityInstanceId because the user can manage drafts
                        $scope.hasManageDrafts && e.entityInstanceId == entityInstanceId
                        // take only the entityInstanceId where the user is initiator 
                        || e.entityInstanceId == entityInstanceId && (!e.isDraft || e.iAmInitiator && e.isDraft)
                    ));
            }
            else if (!hasSelectedPeriod && hasPeriod) {
                // find period based on periodId
                $scope.selectedPeriod = ($scope.periodsDict || []).find(p => p.key == periodId);
            }

            if (!$scope.selectedPeriod && periodId) {
                // if period not found based on routing but the route has a period, take the period
                $scope.selectedPeriod = ($scope.periodsDict || []).find(p => p.key == periodId);
            }

            if (!$scope.selectedPeriod) {
                // no period found based on the routing
                $scope.pp = new ProgressPaymentSA($scope.module, entityInstanceId, moduleTypes, periodId, false, 0, routeParams?.sovEid);
            }
            else {
                if (!$scope.selectedPeriod.hasMultiplePayments) {
                    $scope.pp = new ProgressPaymentSA($scope.module, entityInstanceId || $scope.selectedPeriod.entityInstanceId, moduleTypes, $scope.selectedPeriod.key, false, 0, routeParams?.sovEid);
                }
                else {
                    $scope.get_ppList($scope.selectedPeriod.key);
                }
            }
            });
        }
        
        $scope.loadPP = function (keepPeriods, isFromWatch) {
            if ($scope.$$destroyed) {
                return;
            }
            $scope.pp = null;
            if (!keepPeriods) {
                $scope.currentPeriod = null;
                $scope.selectedPeriod = null;
                if(!isFromWatch) $scope.periodsDict = [];
                $scope.ppList = [];
                $scope.errors = "";
                $scope.get_currentPeriod(isFromWatch);
            } else {
                $scope.get_periods()
                    .then(function() {
                        $scope.reloadOrGetPP();
                    });
            }
        }

        $scope.delete = function () {
            $scope.pp.delete()
                .then(function () {
                    // If we have revisions, we don't want to send sovEid param in url because can be different, but if we don't have revisions, then we want to keep the sovEid param in url so the new PP will be created for the same SOV
                    const revision = $scope.pp?.generalInfo?.revisions?.find(r => r.entityInstanceId != $scope.pp.entityInstanceId);
                    $scope.goToProgressPayment(routeParams.periodId, revision?.entityInstanceId, 
                                               revision?.entityInstanceId ? undefined : ($scope.pp?.generalInfo?.sovEntityInstanceId || $scope.selectedPeriod.sovEntityInstanceId || routeParams?.sovEid));
                })
        }

        $scope.deleteFromList = function (id) {
            $scope.loadingList = true;
            var dataURL = URI.PROGRESS_PAYMENT.PP_DELETE;
            Model[dataURL.method](dataURL, { url: { contractId: userService.system.userdata.contractId, entityInstanceId: id }, urltype: 'obj' })
                .then(function () {
                    $scope.get_ppList($scope.selectedPeriod.key);
                })
                .catch(function () {
                    Message.dberror(e);
                    $scope.loadingList = false;
                })
        }

        $scope.Math = Math;

        $scope.$watch(function () {
            return userService.isLoadingMenu;
        },
            function (n, o) {
                if (!n && typeof userService.getOperationsFor(moduleCode).Read != 'undefined') {
                    isPeriodsLoaded = false;
                    var keepPeriods = (routeParams.periodId * 1) !== 0 || (routeParams.entityInstanceId * 1) !== 0;
                    $scope.loadPP(keepPeriods, true);
                } else if (!n) {
                    $state.go("tenant.404", { tenantIdentifier: routeParams.tenantIdentifier });
                }
            });

        $scope.$watch(function () {
            return userService.isCurrentContractPeriodsChanged;
        },
            function (n, o) {
                if (n) {
                    routeParams.periodId = 0;
                    routeParams.entityInstanceId = 0;
                    $scope.get_periods(true);
                    userService.isCurrentContractPeriodsChanged = false;
                }
            });

        var confirm = function (title, text, ev) {
            return $mdDialog.confirm()
                .title(title)
                .textContent(text)
                .ariaLabel('Confirm Dialogue')
                .targetEvent(ev)
                .ok('Proceed')
                .cancel('Cancel');
        }

        $scope.startTransition = function (t, role) {
            var anyChanges = $scope.pp.anyChangesOnModules();
            if (anyChanges) {
                $mdDialog.show(confirm(`Submit ${$scope.pp.moduleName}`, `Continuing with this action will discard any unsaved changes. Are you sure?`))
                    .then(function () {
                        $scope.startTransitionInternal(t, role);
                    })
                    .catch(function (e) {
                        // cancel pressed
                    });
            } else {
                $scope.startTransitionInternal(t, role);
            }
        }

        $scope.startTransitionInternal = function (t, role) {
            // update screen before starting a transition
            // the screen will be updated only if in edit mode
            $scope.pp.updateScreen().then(function() {
                // in case we have other drafts, then we need to show a message
                if ($scope.pp.isDraft && !t.isDraft && $scope.pp.generalInfo.otherDraftsUser && $scope.pp.generalInfo.otherDraftsUser.length) {
                    $mdDialog.show(confirm(`Submit ${$scope.pp.moduleName}`, `Submitting the ${$scope.pp.moduleName} will delete drafts created by other users. Continue ?`))
                    .then(function () {
                        doStartTransition(t, role);
                    })
                    .catch(function (e) {
                        // cancel pressed
                    });
                }
                else {
                    doStartTransition(t, role);
                }
            });
        };

        $scope.toggleNodeItems = function(module, node) {
            node.isExpanded = !node.isExpanded;

            if (node.hasItems && node.isExpanded) {
                node.items = $scope.pp.toggleModuleItems(module, 1, node);
            }
        }

        var doStartTransition = function(t, role) {
            $scope.pp.isBusy = true;
            if (parseInt(t.stateTypeId) !== 0 && !t.isRevise && !t.isDraft) {
                var getFields_param = t.isComment ? { actionId: t.id } : { transitionId: t.id };
                $scope.pp.get_fields(getFields_param)
                    .then(function (r) {
                        if (t.isAutoTrigger && !(r.requiresNonBindingSignature && !$scope.nonBindingSignature) 
                            || r && !r.fields.length && r.hideRolesNotify && !(r.requiresNonBindingSignature && !$scope.nonBindingSignature) 
                            || r && !r.fields.length && !r.emailsDataSource.length && !r.hideRolesNotify && !(r.requiresNonBindingSignature && !$scope.nonBindingSignature)) {
                            $scope.pp.save(t.id, role.key, false, r.emails, r.roleToExcludeIds)
                                .then(function () {
                                    // var period = $scope.pp.period || null;
                                    $scope.pp.get_general_info();
                                    $scope.get_periods();

                                    // clear edit mode
                                    $scope.pp.editMode = false
                                })
                                .catch(function () { });
                        }
                        else {
                            $scope.pp.isBusy = false;
                            r.rolesDict = angular.copy($scope.pp.rolesDict);
                            r.saveParams = {
                                contractId: $scope.pp.contractId,
                                roleId: role.key,
                                entityInstanceId: $scope.pp.entityInstanceId,
                                paymentPeriodId: $scope.pp.period ? $scope.pp.period.key : ($scope.pp.selectedPeriodId || 0),
                                moduleTypeId: ($scope.pp.currentType || {}).key || $scope.pp.types[0].key
                            };
                            showTransitionScreen(r, t);
                        }
                    })
                    .catch(function () { });
            } else {
                $scope.pp.save(t.id, role?.key, t.isRevise)
                    .then(function (newEntityInstanceId) {
                        if (t.isRevise) {
                            $scope.goToProgressPayment(routeParams.periodId, newEntityInstanceId);
                        } else {
                            $scope.pp.get_general_info()
                            $scope.get_periods();

                            // clear edit mode
                            $scope.pp.editMode = false;
                        }
                    })
                    .catch(function () { });
            }
        }

        var showTransitionScreen = function (r, t) {
            var dataURL, entityInstanceId, ppPeriodId;
            dataURL = URI.PROGRESS_PAYMENT.PP_SAVE;
            if (t.isComment) dataURL = URI.MODULE.ADD_COMMENT;
            entityInstanceId = $scope.pp.entityInstanceId;
            
            $mdDialog.show({
                locals: {
                    info: r,
                    transition: t,
                    entityInstanceId: entityInstanceId,
                    dataURL: dataURL,
                    contractId: userService.system.userdata.contractId,
                    isPayment: true,
                    selectedRoleId: r.saveParams.roleId,
                    startScreenValues: $scope.pp.generalInfo.isDraftState ? $scope.pp.propertiesScreen.valuesDictionary || [] : [],
                },
                controller: 'editTransitionScreenController',
                templateUrl: '/ng/views/admin/modals/editTransitionScreen.html',
                parent: angular.element(document.body),
                fullscreen: true,
                escapeToClose: false,
                clickOutsideToClose: false
            })
            .then(function (r) {
                $scope.pp.entityInstanceId = r;
                // var period = $scope.pp.period || null;
                $scope.pp.get_general_info();
                $scope.get_periods();

                // clear edit mode
                $scope.pp.editMode = false;
            });
        }

        $scope.assign_User = function (user) {
            // update screen before user assignment
            // the screen will be updated only if in edit mode
            $scope.pp.updateScreen().then(function() {
                $scope.pp.assign_User(user);
            });
        }

        $scope.toggleEditMode = function () {
            var anyChanges = $scope.pp.anyChangesOnModules();
            if (anyChanges) {
                $mdDialog.show(confirm(`Save Updates`, `Continuing with this action will discard any unsaved changes. Are you sure?`))
                    .then(function () {
                        $scope.toggleEditModeInternal();
                    })
                    .catch(function (e) {
                        // cancel pressed
                    });
            } else {
                $scope.toggleEditModeInternal();
            }
        }

        $scope.toggleEditModeInternal = function() {
            // update screen before toggling edit mode
            // the screen will be updated only if in edit mode
            $scope.pp.updateScreen().then(function() {
                $scope.pp.toggleEditMode();
            });
        }
    });
